import { z } from 'zod'
import { oc } from '@orpc/contract'
import { cellRefSchema } from './boards-shared.contract'

const ownerSchema = z.object({ reference: z.string(), display: z.string() }).nullable()

export const boardAdminList = oc
  .route({ method: 'GET', path: '/v2/boards-admin' })
  .input(z.object({}).optional())
  .output(
    z.object({
      boards: z.array(
        z.object({
          id: z.string(),
          name: z.string(),
          orgId: z.string().optional(),
          orgName: z.string().optional(),
          owner: ownerSchema,
        }),
      ),
    }),
  )

export const boardOwnerCandidates = oc
  .route({ method: 'GET', path: '/v2/boards-admin/{id}/owner-candidates' })
  .input(z.object({ id: z.string() }))
  .output(z.object({ candidates: z.array(cellRefSchema) }))

export const boardSetOwner = oc
  .route({ method: 'POST', path: '/v2/boards-admin/{id}/owner' })
  .input(z.object({ id: z.string(), ownerRef: z.string().nullable() }))
  .output(z.object({ id: z.string(), owner: ownerSchema }))
